"use client";
import { jsx as t } from "react/jsx-runtime";
import x from "../../blocks/Benefits/Benefits.js";
import { useTracking as v, useEnvironment as k, Box as b, sharedHandler as w, Alert as d } from "@ingeniorforeningen/figurine-core";
import "axios";
import D from "../../blocks/CallToAction/CallToAction.js";
import A from "../../blocks/Cards/Cards.js";
import S from "../../blocks/Cluster/Cluster.js";
import U from "../../blocks/ConditionBox/ConditionBox.js";
import m from "../../blocks/Embed/Embed.js";
import { embedDataWrapperDeliveryApiParser as M, embedPlayableDeliveryApiParser as B } from "../../blocks/Embed/Embed.helpers.js";
import G from "../../blocks/EmployeeCards/EmployeeCards.js";
import L from "../../blocks/FactBox/FactBox.js";
import N from "../../blocks/IconGrid/IconGrid.js";
import I from "../../blocks/List/List.js";
import { listDeliveryTaggedContentFilter as $ } from "../../blocks/List/List.helpers.js";
import E from "../../blocks/Media/Media.js";
import F from "../../blocks/MultiBoxes/MultiBoxes.js";
import H from "../../blocks/PageTop/PageTop.js";
import K from "../../blocks/PersonCards/PersonCards.js";
import R from "../../blocks/Picture/Picture.js";
import W from "../../blocks/ProductSelector/ProductSelector.js";
import j from "../../blocks/RecommendedLink/RecommendedLink.js";
import q from "../../blocks/Richtext/Richtext.js";
import Y from "../../blocks/Schema/Schema.js";
import z from "../../blocks/SingleTrackProgram/SingleTrackProgram.js";
import J from "../../blocks/Spotbox/Spotbox.js";
import n from "../../blocks/Tables/Tables.js";
import { threeColumnTableDeliveryApiParser as O, ticketTableDeliveryApiParser as Q, contactTableDeliveryApiParser as V } from "../../blocks/Tables/Tables.helpers.js";
import X from "../../blocks/Usp/Usp.js";
import p from "../../layout/Container/Container.js";
import { forwardRef as Z, useEffect as ee } from "react";
import { extractComponents as te, resolvePadding as _ } from "./UmbracoGrid.helpers.js";
import '../../../assets/UmbracoGrid.css';const re = "_wrapper_1dl1n_2", ae = {
  wrapper: re
}, l = Z((g, T) => {
  const { data: a, customComponent: u, taggedContent: h, ...y } = g, f = a?.contentType === "miniCMS_contentpage" || a?.contentType === "miniCMS_frontpage", C = v(), s = te(a, f), {
    variables: { env: i }
  } = k();
  ee(() => {
    if (f) {
      a.properties?.metaTitle && (document.title = `${a.properties?.metaTitle} | IDA`);
      const e = document.querySelector('meta[name="description"]'), r = a.properties?.metaDescription;
      e && r && e.setAttribute("content", r);
    }
  }, []);
  const c = (e) => {
    let r;
    switch (e.content.contentType) {
      case "shared_taggedList":
        return h ? (r = $(
          e.content,
          h,
          a?.id || ""
        ), !r || r.length < 1 ? null : /* @__PURE__ */ t(I, { data: e.content, items: r })) : i !== "prod" ? /* @__PURE__ */ t(p, { children: /* @__PURE__ */ t(
          d,
          {
            type: "error",
            text: `A Tagged list has been set up in Umbraco but the tagged 
                  content to lookup has not been sent to the UmbracoGrid component`,
            title: "Missing Tagged List Data",
            m: "auto"
          }
        ) }) : null;
      case "shared_multiBox":
        return /* @__PURE__ */ t(F, { data: e });
      case "shared_Cards":
        return /* @__PURE__ */ t(A, { data: e });
      case "shared_benefits":
        return /* @__PURE__ */ t(x, { data: e });
      case "shared_iconGrid":
        return /* @__PURE__ */ t(N, { data: e });
      case "shared_personCardsWithText":
        return /* @__PURE__ */ t(K, { data: e });
      case "shared_employeesList":
        return /* @__PURE__ */ t(G, { data: e });
      case "shared_topicHighlight":
      case "shared_topicHighlightSimple":
        return /* @__PURE__ */ t(S, { data: e });
      case "shared_spotBox":
        return /* @__PURE__ */ t(J, { data: e.content });
      case "shared_richText":
        return /* @__PURE__ */ t(q, { data: e.content });
      case "shared_image":
        return /* @__PURE__ */ t(R, { data: e.content });
      case "shared_playable":
        return /* @__PURE__ */ t(m, { data: e.content, customParser: B });
      case "shared_data_wrapper":
        return /* @__PURE__ */ t(m, { data: e.content, customParser: M });
      case "shared_iFrame":
        return /* @__PURE__ */ t(m, { data: e.content });
      case "shared_button":
        return /* @__PURE__ */ t(D, { data: e.content });
      case "shared_usp":
        return /* @__PURE__ */ t(X, { data: e.content });
      case "shared_contactTable":
        return /* @__PURE__ */ t(n, { data: e.content, customParser: V });
      case "shared_priceTable":
        return /* @__PURE__ */ t(n, { data: e.content, customParser: Q });
      case "shared_3ColumnTable":
        return /* @__PURE__ */ t(n, { data: e.content, customParser: O });
      case "shared_simpleTable":
        return /* @__PURE__ */ t(n, { data: e.content });
      case "shared_factBox":
        return /* @__PURE__ */ t(L, { data: e.content });
      case "shared_video":
        return /* @__PURE__ */ t(E, { data: e.content });
      case "shared_recommendedLinks":
        return /* @__PURE__ */ t(j, { data: e.content });
      case "shared_singleTrackProgram":
        return /* @__PURE__ */ t(z, { data: e.content });
      case "shared_conditionBox":
        return /* @__PURE__ */ t(U, { data: e.content });
      case "shared_optionalCoverageTable":
      case "shared_coverageTable":
        return /* @__PURE__ */ t(Y, { data: e.content });
      case "studentInsuranceCalculator":
        return /* @__PURE__ */ t(W, { data: e.content });
      case "shared_pageTop":
        return /* @__PURE__ */ t(H, { data: e.content });
      case "shared_blocks_sharedContent":
      case "shared_blocks_reusableComponent":
        return e.content.properties?.component?.[0].properties.blocks?.items.map(
          (o) => c(o)
        );
      case "miniCMS_customComponent":
        if (u) {
          const o = u.find(
            (P) => P.key === e.content.properties?.propertyKey
          );
          if (o?.component)
            return o.component;
        }
        return i !== "prod" ? /* @__PURE__ */ t(p, { children: /* @__PURE__ */ t(
          d,
          {
            type: "error",
            text: `No component is mapped to KEY "${e.content.properties?.propertyKey}" `,
            title: "Missing Custom Component",
            m: "auto"
          }
        ) }) : null;
      default:
        return i !== "prod" ? /* @__PURE__ */ t(p, { children: /* @__PURE__ */ t(
          d,
          {
            type: "error",
            text: `The component "${e.content.contentType}" is not mapped in the UmbracoGrid.
                This alert will not be shown in production, but will be tracked to Application Insights.`,
            title: "Umbraco Component Not Mapped",
            m: "auto"
          }
        ) }) : (C?.monitor?.exception({
          message: `An Umbraco Block in the backoffice grid is not mapped in the UmbracoGrid 
          and will not be shown on the website.`,
          severityLevel: 3,
          properties: { componentName: e.content.contentType }
        }), /* @__PURE__ */ t("div", {}));
    }
  };
  return /* @__PURE__ */ t(b, { ...y, ref: T, children: /* @__PURE__ */ t("div", { className: ae.wrapper, children: s.map((e, r) => {
    const o = e.content.id || `umbracoGridChild${Math.random().toString(36)}`;
    return c(e) ? /* @__PURE__ */ t(
      b,
      {
        pt: _(
          e?.content?.contentType,
          s[r - 1]?.content?.contentType
        ),
        pb: _(
          e?.content?.contentType,
          s[r + 1]?.content?.contentType
        ),
        children: c(e)
      },
      o
    ) : null;
  }) }) });
});
l.displayName = "UmbracoGrid";
const oe = w(l);
oe.displayName = l.displayName;
export {
  ae as U,
  l as _UmbracoGrid,
  oe as default
};
